<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='LK_Inventory' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <!--      栅格布局-->
      <el-row class="fh">
        <el-col :span="8" class="fh ls-border">
          <el-card shadow="never" class="card-body-none fh" style="overflow-y: auto">
            <div slot="header" class="clearfix">
              <!--              点击所有存货，展示所有数据-->
              <el-button type="text" style="padding: 0 11px" @click="getAllMenus">所有存货>></el-button>
            </div>
            <!--            树形结构的表格   columns：查看所选择的某一个连续范围内的一系列单元格的总列数-->
            <tree-table highlight-current-row :data="modulesTree" :columns="columns" @row-click="treeClick"
                        border></tree-table>
          </el-card>
        </el-col>
        <el-col :span="16" class="fh ls-border">
          <div class="bg-white fh" id='lKInventorys-table'>
            <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit
                      highlight-current-row
                      style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                      @selection-change="handleSelectionChange" @sort-change="handleSortChange">
              <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
              <el-table-column type="selection" align="center" width="55"></el-table-column>
              <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                               :label="item.description"
                               :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                               :show-overflow-tooltip="item.tooltip">
                <template slot-scope="scope">
                  <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                               v-if="item.isSel">
                  </select-type>
                  <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{ scope.row[item.key] | dateFormat }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                        :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
          </div>
        </el-col>
      </el-row>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="lKInventorys-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData">
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="lKInventorys-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp">
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
    </div>
  </div>
</template>

<script>
import * as lKInventorys from '@/api/lk_inventorys';
import mytable from '@/utils/crmtableFlowV2';
// 导入树形表格
import treeTable from '@/components/TreeTable';
import * as inventoryclasss from '@/api/inventoryclasss';
// 导入树形结构插件
// import Treeselect from '@riophae/vue-treeselect'
// 导入样式
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'lKInventorys',
  components: { treeTable },
  mixins: [mytable],
  data() {
    return {
      crmType: 'LK_Inventory',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      modules: [], // 模块
      modulesTree: [], // 树形模块
      initData: {
        AccountId: ''
      },
      columns: [
        // treetable的列名
        {
          text: '分类编号',
          value: 'cInvCCode'
        },
        {
          text: '分类名称',
          value: 'cInvCName'
        }
      ],
      rules: {}
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  mounted() {
    // 初始化页面完成后，刷新树形结构
    this.getModulesTree();
  },
  methods: {
    getApi() {
      return lKInventorys;
    },
    // 点击所有存货，展示所有数据的方法  listQuery查询
    getAllMenus() {
      this.currentModule = null;
      let whereobj = this.listQuery.wheres ? JSON.parse(this.listQuery.wheres) : [];
      if (whereobj) {
        whereobj = this.AssTableData([{
          field: 'cInvCCode',
          value: null,
          relation: '=='
        }], whereobj);
      }
      this.listQuery.wheres = JSON.stringify(whereobj);
      this.getList();
    },
    // 递归
    recursion(array, data) {
      // 定义临时的数组
      const interim = this.modules.filter(u => u.parentCode === data.cInvCCode);
      for (let i = 0; i < interim.length; i++) {
        // 把子集放进去
        array.push(interim[i].cInvCCode);
        this.recursion(array, interim[i]);
      }
    },

    // 左侧treetable点击事件
    treeClick(data) {
      // 先定义一个数组,放父级和父级本身以及下面子集的数据
      const array = [];
      // 先把自己放进去
      array.push(data.cInvCCode);
      this.recursion(array, data);
      console.log(array);
      // // 先找到上面父级下面的子集 在所有数组里面找到parentCode是父级要找的编号的。就是要找的
      // const interim = this.modules.filter(u => u.parentCode === data.cInvCCode)
      // for (let i = 0; i < interim.length; i++) {
      //   // 把子集放进去
      //   array.push(interim[i].cInvCCode)
      // }
      this.currentModule = data;
      // this.currentModule.parent = null
      let whereobj = this.listQuery.wheres ? JSON.parse(this.listQuery.wheres) : [];
      if (whereobj) {
        whereobj = this.AssTableData([{
          field: 'cInvCCode',
          value: array.join(),
          relation: 'in'
        }], whereobj);
      }
      this.listQuery.wheres = JSON.stringify(whereobj);
      this.getList();
    },
    // 树结构传出数据方法
    getModulesTree() {
      var _this = this; // 记录vuecomponent
      inventoryclasss.getAllData().then(response => {
        _this.modules = response.result.map(function(item) {
          return {
            id: item.id,
            cInvCCode: item.cInvCCode,
            cInvCName: item.cInvCName,
            parentCode: item.parentCode
          };
        });
        // 将一个带层级的数据列表转成树结构
        var modulestmp = _this.modules.map(o => ({ ...o }));
        console.log(modulestmp);
        _this.modulesTree = _this.$utils.toArrayTree(modulestmp, {
          key: 'cInvCCode',
          parentKey: 'parentCode',
          strict: true
        });
      });
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'lKInventorys') {
        this.drawertemp = { ...this.drawertemp, ...row };
        this.menukeyArray = [
          { name: '', menukey: 'lk_inventorysview' }
        ]; // 要显示的标签
        this.drawer = true;
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#lKInventorys-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}
</style>
